import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type CostAnalysis } from '../../api/optimization';

export function CostIntelligencePage() {
  const [costs, setCosts] = useState<CostAnalysis[]>([]);
  useEffect(() => { void optimizationApi.cost().then(setCosts); }, []);
  const total = costs.reduce((s, c) => s + c.current_usd, 0);
  const savings = costs.reduce((s, c) => s + c.savings_usd, 0);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Cost Intelligence Dashboard</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2"><div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Total Monthly Cost</p><p className="text-2xl font-semibold">${total.toFixed(0)}</p></div><div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Projected Savings</p><p className="text-2xl font-semibold">${savings.toFixed(0)}</p></div></div>
      <div className="mt-6 space-y-3">{costs.map((c) => (
        <div key={c.id} className="rounded-xl border p-4 dark:border-slate-700"><p className="font-medium capitalize">{c.module}</p><p className="text-sm text-slate-500">Current ${c.current_usd} → Projected ${c.projected_usd} · Save ${c.savings_usd}</p></div>
      ))}</div>
    </div>
  );
}
